(($, Drupal) => {
  "use strict";

  Drupal.toggleOlexAiSection = function (context) {
    const checkbox = $('#toggle-olexai-feedback-section', context).once('toggleOlexAi');
    const details = $('#edit-further-details', context);

    if (!checkbox.length || !details.length) return;

    // Function to update UI based on checkbox state
    const updateSectionVisibility = () => {
      const checked = checkbox.is(':checked');
      details.toggleClass('hide-feedback', checked);

      if (checked) {
        const tableCheckboxes = $('input.js-olexai-feedback-options-table[type="checkbox"]:checked', context);
        tableCheckboxes.prop('checked', false).trigger('change');
        tableCheckboxes.each(function () {
          $(this).closest('tr.selected').removeClass('selected');
        });
      }
    };

    // Bind change event
    checkbox.off('change.toggleOlexAi').on('change.toggleOlexAi', updateSectionVisibility);

    // Initialize on load
    updateSectionVisibility();
  };

  // Attach as a Drupal behavior as well
  Drupal.behaviors.toggleOlexAiSection = {
    attach: function (context, settings) {
      Drupal.toggleOlexAiSection(context, settings);
    }
  };

})(jQuery, Drupal);
